var map = {
	"./PWA.png": 518,
	"./README.png": 433,
	"./github-logo.png": 205,
	"./linkedin-logo.png": 572,
	"./me.png": 635,
	"./notes.png": 550,
	"./resume.pdf": 162,
	"./starwar.png": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;